import { DialogTitle } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import React from 'react';
import useStyles from '../styles';
import { Form } from 'react-final-form';
import NewEventTypeForm from './NewEventTypeForm';
import { createEventType } from '../../api';
import { useSnackbar } from 'notistack';

const NewEventTypeDialogContent = ({calendar_id, closeNewEventTypeInput, filteredServices}) => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    return (
        <>
            <DialogTitle className={classes.dialogTile}>
                <div className={classes.mainHeading}>
                    Event setup
                </div>
                <div className={classes.generalText}>
                    Create an event
                </div>
            </DialogTitle >
            <DialogContent sx={{ overflowY: 'scroll' }}>
                <Form
                    onSubmit={(values) => {
                        createEventType({calendar_id,...values}).then(
                            (r)=>{
                                closeNewEventTypeInput();
                                window.location.reload();
                            }
                        ).catch(()=>{
                            enqueueSnackbar(`Failed to create event type`, { variant: 'error' });
                        })
                    }}
                    closeNewEventType={closeNewEventTypeInput}
                    filteredServices={filteredServices}
                    component={NewEventTypeForm}
                />
            </DialogContent>
    </>
    )
}

export default NewEventTypeDialogContent;
